/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiIdentityAccountForgotpasswordPost } from '../fn/forgot-password/api-identity-account-forgotpassword-post';
import { ApiIdentityAccountForgotpasswordPost$Params } from '../fn/forgot-password/api-identity-account-forgotpassword-post';
import { apiIdentityAccountForgotpasswordPost$Plain } from '../fn/forgot-password/api-identity-account-forgotpassword-post-plain';
import { ApiIdentityAccountForgotpasswordPost$Plain$Params } from '../fn/forgot-password/api-identity-account-forgotpassword-post-plain';
import { apiIdentityAccountResetpasswordPost } from '../fn/forgot-password/api-identity-account-resetpassword-post';
import { ApiIdentityAccountResetpasswordPost$Params } from '../fn/forgot-password/api-identity-account-resetpassword-post';
import { apiIdentityAccountResetpasswordPost$Plain } from '../fn/forgot-password/api-identity-account-resetpassword-post-plain';
import { ApiIdentityAccountResetpasswordPost$Plain$Params } from '../fn/forgot-password/api-identity-account-resetpassword-post-plain';
import { ForgotPasswordResponse } from '../models/forgot-password-response';
import { Response } from '../models/response';

@Injectable({ providedIn: 'root' })
export class ForgotPasswordService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiIdentityAccountForgotpasswordPost()` */
  static readonly ApiIdentityAccountForgotpasswordPostPath = '/api/identity/account/forgotpassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityAccountForgotpasswordPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountForgotpasswordPost$Plain$Response(params?: ApiIdentityAccountForgotpasswordPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ForgotPasswordResponse>> {
    return apiIdentityAccountForgotpasswordPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityAccountForgotpasswordPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountForgotpasswordPost$Plain(params?: ApiIdentityAccountForgotpasswordPost$Plain$Params, context?: HttpContext): Observable<ForgotPasswordResponse> {
    return this.apiIdentityAccountForgotpasswordPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ForgotPasswordResponse>): ForgotPasswordResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityAccountForgotpasswordPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountForgotpasswordPost$Response(params?: ApiIdentityAccountForgotpasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ForgotPasswordResponse>> {
    return apiIdentityAccountForgotpasswordPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityAccountForgotpasswordPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountForgotpasswordPost(params?: ApiIdentityAccountForgotpasswordPost$Params, context?: HttpContext): Observable<ForgotPasswordResponse> {
    return this.apiIdentityAccountForgotpasswordPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ForgotPasswordResponse>): ForgotPasswordResponse => r.body)
    );
  }

  /** Path part for operation `apiIdentityAccountResetpasswordPost()` */
  static readonly ApiIdentityAccountResetpasswordPostPath = '/api/identity/account/resetpassword';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityAccountResetpasswordPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountResetpasswordPost$Plain$Response(params?: ApiIdentityAccountResetpasswordPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityAccountResetpasswordPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityAccountResetpasswordPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountResetpasswordPost$Plain(params?: ApiIdentityAccountResetpasswordPost$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityAccountResetpasswordPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityAccountResetpasswordPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountResetpasswordPost$Response(params?: ApiIdentityAccountResetpasswordPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityAccountResetpasswordPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityAccountResetpasswordPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityAccountResetpasswordPost(params?: ApiIdentityAccountResetpasswordPost$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityAccountResetpasswordPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

}
